const phoneMappingConfig: PhoneMapping = {
  default: {
    number: '8886110712',
    pretty: '(888) 611-0712'
  },
  radio: {
    number: '8006003590',
    pretty: "(800) 600-3590"
  },
  facebook: {
    number: '8884030946',
    pretty: '(888) 403-0946'
  },
  BingSearchNetwork: {
    number: '8882586360',
    pretty: '(888) 258-6360'
  },
  GoogleSearchNetwork: {
    number: '8885350978',
    pretty: '(888) 535-0978'
  },
  GoogleDisplayNetwork: {
    number: '8885350978',
    pretty: '(888) 535-0978'
  },
  directmail: {
    number: '8552750187',
    pretty: '(855) 275-0187'
  },
  lifeNetCreative: {
    number: '8884031021',
    pretty: '(888) 403-1021'
  },
  lifeMailerCreative: {
    number: '8884031022',
    pretty: '(888) 403-1022'
  },
  lifeStealthCreative: {
    number: '8884031028',
    pretty: '(888) 403-1028'
  },
  lifeGuaranteedIssue: {
    number: '8559211797',
    pretty: '(855) 921-1797'
  },
  autoInsurance: {
    number: '8667192130',
    pretty: '(866) 719-2130'
  }
}

export default phoneMappingConfig
